import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-appliance',
  templateUrl: './home-appliance.component.html',
  styleUrls: ['./home-appliance.component.scss']
})
export class HomeApplianceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
